module.exports = __webpack_public_path__ + "img/Terraform-4-mobile.2da5a94c.png";